import React from 'react'

import clsx from 'clsx'

import { NumberIncreaseAnimation } from 'src/common/animations/NumberIncreaseAnimation/NumberIncreaseAnimation'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import s from './NumberBlock.module.scss'

export type NumberBlockProps = {
  titleNumber: number
  description: string
  titlePostfix?: string
  className?: string
}

export const NumberBlock: React.FC<NumberBlockProps> = ({
  titleNumber,
  description,
  titlePostfix,
  className,
}) => {
  return (
    <div className={clsx(className)}>
      <Typography
        variant={EnumTypographyVariants.H1}
        as="div"
        className={s.NumberBlock__title}
      >
        <NumberIncreaseAnimation
          finalValue={titleNumber}
          animationConfig={{ from: { value: titleNumber - 50 } }}
        />
        {titlePostfix}
      </Typography>
      <Typography
        variant={EnumTypographyVariants.H5}
        as="p"
        text={description}
      />
    </div>
  )
}
